export const getDisabledIntegrationsForCRMPhoneField = (settings: unknown) => {
  if (settings === null || settings === undefined) return []

  let clearSettings: Record<string, any> = {}

  if (typeof settings === 'string') {
    try {
      clearSettings = JSON.parse(settings)
    } catch (error) {
      console.error('Error parsing settings:', error)
      return []
    }
  } else {
    clearSettings = settings
  }

  // Ищем строку с disabled_integrations среди массива строк
  const dirtyString = clearSettings?.['disabled_integrations']

  if (!dirtyString) return []
  if (Array.isArray(dirtyString)) return dirtyString

  try {
    const parsed = JSON.parse(dirtyString)
    if (Array.isArray(parsed)) return parsed
    return []
  } catch {
    return []
  }
}
